import React from 'react';
import { Select } from 'tea-component'; //
import { useIntl } from 'umi';
import TipContext from '@home/components/TipContextComponents/TipContext';
export default function SelectSource(props: any) {
  const { buttonName, buttonIcon, placeholder, isShowButtonLabel, options, value, tips, AWidth, style } = props;
  const { formatMessage } = useIntl();
  const button = () => {
    const valueUI = (() => {
      const option = options?.find((t: any) => t?.value === value);
      const optionBtnText = option?.buttonText;
      const optionText = option?.text;
      const optionTextResult = optionBtnText || optionText;
      if (optionTextResult) {
        return optionTextResult;
      }
      return placeholder || '';
    })();
  const isEmpty = (
    value: unknown
  ): value is null | undefined | '' => {
    return value == null || (typeof value === 'string' && value.trim() === '');
  };
    return (
      <div className="dbi-select-button">
        <span className="select-button-text">
          {buttonIcon}
          {isShowButtonLabel && buttonName && `${buttonName} `}
        </span>
        {tips && (
          <div style={{ marginRight: 6, lineHeight: 0 }}>
            <TipContext Performance="left" AWidth={AWidth} tipText={formatMessage({ id: tips })} />
          </div>
        )}
        <span
          className="select-button-value"
          style={isEmpty(value)? { color: 'var(--color-neutral-3)' } : undefined}
        >
          {valueUI || placeholder || ''}
        </span>
      </div>
    );
  };
  return <Select {...props} button={button} style={style || { width: '218px' }} />;
}
